import { createHttpLink } from "@apollo/client";
import { graphql_server_url, graphql_local_url } from "../../constants/gql";
const httpLink = createHttpLink({
    uri: graphql_server_url,
});

export default httpLink;